import React, {useCallback, useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {Loader} from "../../../../components/admin/Loader";
import {officeMemberResultCollectionType, officeMemberResultType} from "../../../../types/Api/OfficeMemberResultType";
import {office} from "../../../../models/office";
import {officeMember} from "../../../../models/officeMember";
import {officeMemberHydrator} from "../../../../models/hydrator/officeMemberHydrator";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {OfficeForm} from "../../../../components/admin/office/OfficeForm";
import {member} from "../../../../models/member";
import {memberResultCollectionType, memberResultType} from "../../../../types/Api/MemberResultType";
import {memberHydrator} from "../../../../models/hydrator/memberHydrator";

export const Edit = () => {
  const uuid: undefined | string = useParams().uuid;

  const [office, setOffice] = useState(undefined as undefined | office);
  const [officeMember, setOfficeMember] = useState([] as officeMember[]);
  const [member, setMember] = useState([] as member[]);
  const [loading, setLoading] = useState(false);

  const findOffice = useCallback(() => {
    if (uuid) {
      const apiFilters: ApiQueryParam = new ApiQueryParam();

      apiFilters.addFilter({
        field: 'officeId',
        op: 'eq',
        value: uuid
      });

      apiFilters.addSort({
        by: 'order',
        direction: 'ASC'
      });

      apiFilters.setCount(0);

      setLoading(true);

      const result = ApiService.get(`/office-member`, apiFilters) as Promise<officeMemberResultCollectionType>;

      result
        .then((officeMemberResultCollection: officeMemberResultCollectionType) => {
          setOfficeMember(officeMemberResultCollection._embedded["office-members"].map((om: officeMemberResultType) => {
            return officeMemberHydrator.hydrate(om);
          }));
        })
        .catch((e: any) => {
          console.log(e);
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [uuid])

  const findMember = useCallback(() => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'firstname',
      direction: 'ASC'
    });

    apiFilters.addSort({
      by: 'name',
      direction: 'ASC'
    });

    setLoading(true);

    const result = ApiService.get(`/member`, apiFilters) as Promise<memberResultCollectionType>;

    result
      .then((memberResultCollection: memberResultCollectionType) => {
        setMember(memberResultCollection._embedded.members.map((m: memberResultType) => {
          return memberHydrator.hydrate(m);
        }));
      })
      .catch((e: any) => {
        console.log(e);
        alert("Une erreur c'est produite.")
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setOffice(
      officeMember.length > 0 ? officeMember[0].office : undefined
    )
  }, [officeMember])

  useEffect(() => {
    findOffice()
  }, [member, findOffice, uuid]);

  useEffect(() => {
    findMember()
  }, [findMember]);

  return (
    <>
      <BoxTitle title={`Modifier le bureau`}/>

      {loading && (
        <Loader/>
      )}

      {!loading && office && officeMember && (
        <OfficeForm office={office} officeMember={officeMember} member={member} />
      )}
    </>
  );
}
